import { useProductStore } from "src/stores/product";
import { useQuasar } from "quasar";
import PDialogForm from "src/components/PDialogForm.vue";

export function useRejectProduct({ closeForm, formData, permissions }) {
  const $q = useQuasar();

  const isRejectLoading = ref(false);

  const { putRejectProduct } = useProductStore();

  const rejectToggleStatus = async (reason, dialog) => {
    dialog.hide();

    isRejectLoading.value = true;

    const payload = { ...unref(formData), reason: unref(reason) };

    await putRejectProduct(payload);

    isRejectLoading.value = false;

    closeForm(true);
  };

  const confirmRejectToggleStatus = () => {
    const { name } = unref(formData);
    let title = "Reject";
    const dialog = $q.dialog({
      component: PDialogForm,
      componentProps: {
        title: `${title} Product`,
        label: `Are you sure you want to ${title} ${name}?`,
        labelClass: "text-center q-my-md q-pa-md bg-surface rounded-borders",
        labelTextClass: "text-md text-neutral text-weight-medium q-px-md",
        form: {
          input: {
            required: true,
            type: "textarea",
            autogrow: true,
            placeholder: "Enter reason for rejection",
            label: "Reason",
            labelClasses: "text-sm text-neutral",
          },
        },
        submittable: true,
        cancellable: true,
        cancelLabel: "Cancel",
        closable: true,
        onConfirm: (reason) => {
          rejectToggleStatus(reason, dialog);
        },
      },
    });
  };

  const rejectButton = computed(() => {
    return {
      loading: unref(isRejectLoading),
      label: "Reject",
      outline: true,
      color: "error-70",
      type: "button",
      disable: !unref(permissions).products.reject,
      onClick: confirmRejectToggleStatus,
    };
  });

  return {
    rejectButton,
  };
}
